module.exports = __webpack_public_path__ + "static/media/pn.c4a2e49f.svg";